<template>
  <div class="dropdown">
    <button class="btn btn-outline-medium-gray btn-outline-light w-100 dropdown-toggle" type="button" id="option" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      {{ name }}
    </button>
    <form class="dropdown-menu">
      <div class="checkbox" v-for="item in list" :key="item.id">
        <label>
          <input
            type="checkbox"
            :value="item.id"
            :checked="selected[type].filter(el => el.id == item.id).length"
            @change="onChange" />
          <span class="left">{{ item.title }}</span>
          <div v-if="item.hex" class="color" :style="{ background: '#' + item.hex }"></div>
        </label>
      </div>
    </form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapState, mapActions } = createNamespacedHelpers('filters')

export default {

  props: {
    name: null,
    type: [String]
  },

  computed: {
    ...mapState(['lists', 'selected']),

    list () {
      return this.lists[this.type]
    }
  },

  methods: {
    ...mapActions(['select', 'deselect']),

    onChange ({ srcElement }) {
      let id = parseInt(srcElement.value)
      let item = this.list.find(el => el.id === id)

      srcElement.checked
        ? this.select({ type: this.type, item })
        : this.deselect({ type: this.type, item })
    }
  }
}
</script>
